import { render, staticRenderFns } from "./FaceInferenceCta.vue?vue&type=template&id=2fb36cce"
import script from "./FaceInferenceCta.vue?vue&type=script&lang=js"
export * from "./FaceInferenceCta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports